<template>
  <div class="nav">
    <!-- 桌面端图片 -->
    <img class="nav-img-desktop" src="@/assets/nav.png" alt="">
    <!-- 移动端图片 -->
    <img class="nav-img-mobile" src="@/assets/nav_m.png" alt="">
    <div class="nav-container">
      <div class="nav-list">
        <div class="nav-item" v-for="(item, index) in navItems" :key="index">
          <a @click="handleNavClick(item)" class="nav-link" :class="{ 'is-active': isActive(item.path) }">
            <img v-if="item.icon === 'ey0.png'" src="@/assets/ey0.png" :alt="item.alt">
            <img v-else-if="item.icon === 'ey1.png'" src="@/assets/ey1.png" :alt="item.alt">
            <img v-else-if="item.icon === 'ey2.png'" src="@/assets/ey2.png" :alt="item.alt">
            <img v-else-if="item.icon === 'ey3.png'" src="@/assets/ey3.png" :alt="item.alt">
            <!-- <span>{{ $t(item.title) }}</span> -->
            <span>{{ item.title }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

export default {
  name: 'NavComponent',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { t } = useI18n();

    // 导航项配置
    const navItems = [
      // {
      //   path: '/register',
      //   icon: 'ey1.png',
      //   alt: 'Registration',
      //   title: 'nav.registration'
      // },
      // {
      //   path: '/#speakers-m',
      //   icon: 'ey2.png',
      //   alt: 'Speakers',
      //   title: 'nav.speakers'
      // },
      // {
      //   path: '/#conference',
      //   icon: 'ey3.png',
      //   alt: 'Conference Program',
      //   title: 'nav.program'
      // },
      // {
      //   path: '/submission',
      //   icon: 'ey0.png',
      //   alt: 'Abstract Submission',
      //   title: 'nav.submission'
      // }
      {
        path: '/register',
        icon: 'ey1.png',
        alt: 'Registration',
        title: 'Registration'
      },
      {
        path: '/speakers',
        icon: 'ey2.png',
        alt: 'Speakers',
        title: 'Speakers'
      },
      {
        path: '/conference',
        icon: 'ey3.png',
        alt: 'Conference Program',
        title: 'Conference Program'
      },
      {
        path: '/submission',
        icon: 'ey0.png',
        alt: 'Abstract Submission',
        title: 'Abstract Submission'
      }
    ];

    // 处理导航点击事件
    const handleNavClick = (item) => {
      if (item.path === '/speakers' || item.path === '/conference') {
        // 如果当前不在首页，先跳转到首页
        if (route.path !== '/') {
          router.push('/').then(() => {
            // 等待路由跳转完成后再滚动
            setTimeout(() => {
              scrollToSection(item.path.substring(1));
            }, 100);
          });
        } else {
          // 如果已经在首页，直接滚动
          scrollToSection(item.path.substring(1));
        }
      } else {
        // 普通路由跳转
        router.push(item.path);
      }
    };

    // 滚动到指定区域
    const scrollToSection = (sectionId) => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    };

    // 判断当前路由是否激活
    const isActive = (path) => {
      if (path === '/speakers' || path === '/conference') {
        // 锚点链接：检查是否在首页且对应区域可见
        if (route.path === '/') {
          const element = document.getElementById(path.substring(1));
          if (element) {
            const rect = element.getBoundingClientRect();
            return rect.top <= 100 && rect.bottom >= 100;
          }
        }
        return false;
      } else {
        // 普通路由
        return route.path === path;
      }
    };

    return {
      navItems,
      isActive,
      handleNavClick,
      t
    };
  }
}
</script>

<style scoped lang="scss">
.nav {
  width: 100%;
  position: relative;
  background-color: #f3f2f5;

  .nav-img-desktop {
    width: 100%;
    height: auto;
    display: block;
  }

  .nav-img-mobile {
    width: 100%;
    height: auto;
    display: none;
  }

  .nav-container {

    .nav-list {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      max-width: 1400px;
      margin: 0 auto;
      padding: 15px 20px;

      .nav-item {
        flex: 0 0 25%;
        padding: 10px;
        text-align: center;

        .nav-link {
          display: flex;
          flex-direction: row;
          text-decoration: none;
          color: #fff;
          transition: all 0.3s ease;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          img {
            width: 60px;
            height: 60px;
            margin-right: 10px;
            transition: transform 0.3s ease;
          }

          span {
            display: block;
            font-size: 20px;
            text-decoration: none;
            color: #0d74a3;
            text-align: center;
          }

          &:hover {
            span {
              color: #04425c;
            }
          }

          &.is-active {
            span {
              color: #04425c;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .nav {
    .nav-img-desktop {
      display: none;
    }

    .nav-img-mobile {
      display: block;
    }

    .nav-container {
      .nav-list {
        padding: 0 10px;

        .nav-item {
          flex: 0 0 50%;
          padding: 8px;

          .nav-link {
            flex-direction: column;

            img {
              width: 50px;
              height: 50px;
              margin-bottom: 4px;
              margin-right: 0;
            }

            span {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .nav {
    .nav-container {
      .nav-list {
        .nav-item {
          .nav-link {
            flex-direction: column;

            img {
              width: 40px;
              height: 40px;
              margin-bottom: 4px;
              margin-right: 0;
            }

            span {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>